/* eslint-disable react/prop-types */
import JoditEditor from 'jodit-react';
import React, { useRef } from 'react';
// helpers
import { editorConfig } from '../../helpers';

const TextEditor = ({
  name,
  error,
  label,
  value,
  touched,
  required,
  className,
  minHeight,
  handleBlur,
  placeholder,
}) => {
  const editor = useRef(null);

  return (
    <>
      <div className={`form-outline mb-4 DashBoardInputBx DashBoardCreatBx APJoditEditor${className ? ` ${className}` : ''}`}>
        <label id={name} className='form-label' htmlFor={name}>
          {label}
          {required && <span className='RedStar'>*</span>}
        </label>
        <JoditEditor
          name={name}
          ref={editor}
          value={value}
          onBlur={handleBlur}
          config={{
            ...editorConfig,
            placeholder: placeholder,
            minHeight: minHeight || '240px',
          }}
        />
        {
          touched && error && (
            <div className='text-danger'>{error}</div>
          )
        }
      </div>
    </>
  );
};

export default TextEditor;
